import React from 'react';
import { useNavigate } from 'react-router-dom';
import { dataCy, SELECTORS } from '../utils/dataCy';

const Card = ({ title, description, link, Icon }) => {
  const navigate = useNavigate();
  const cardId = title?.toLowerCase().replace(/\s+/g, '-') || 'card';

  return (
    <div
      className="p-6 bg-gray-50 dark:bg-grayButton border border-gray-300 dark:border-grayButtonBorder rounded-lg cursor-pointer shadow-sm hover:shadow-lg transition-transform transform hover:-translate-y-1"
      onClick={() => {
        navigate(link);
        window.scrollTo(0, 0);
      }}
      data-cy={dataCy(SELECTORS.DIV, `home-card-${cardId}`)}
    >
      <div className="flex items-center mb-2">
        {Icon && <Icon className="mr-2 text-gray-900 dark:text-gray-100 text-lg" />}
        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">{title}</h3>
      </div>
      <p className="text-gray-700 dark:text-gray-400">{description}</p>
    </div>
  );
};

export default Card;
